/* Confirmed cart feedback only. It never changes quantities or retries requests. */
(() => {
  if (window.CPShopping) return;
  let toastTimer;
  function announce(message, wishlist = false) {
    const toast = document.querySelector('[data-shopping-toast]');
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.querySelector('[data-shopping-message]').textContent = message;
    const link = toast.querySelector('[data-shopping-link]');
    if (link) link.hidden = !wishlist;
    toast.hidden = false;
    toastTimer = setTimeout(() => { if (!toast.contains(document.activeElement)) toast.hidden = true; }, 5500);
  }
  async function added(source, image) {
    const destination = document.querySelector('cart-icon.header-actions__cart-icon, cart-icon');
    if (!destination || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const start = source?.getBoundingClientRect();
    const end = destination.getBoundingClientRect();
    if (!start || !start.width || !end.width || end.bottom < 0 || end.top > window.innerHeight) return;
    const animations = [];
    let ghost;
    try {
      const src = image?.currentSrc || image?.src;
      if (src && source?.animate) {
        ghost = document.createElement('img');
        ghost.className = 'cp53-bag-flight';ghost.alt = '';ghost.setAttribute('aria-hidden','true');ghost.src = src;
        const size = 44;
        Object.assign(ghost.style,{left:`${start.left + start.width/2-size/2}px`,top:`${start.top + start.height/2-size/2}px`,width:`${size}px`,height:`${size}px`});
        document.body.append(ghost);
        const x = end.left + end.width/2 - start.left - start.width/2;
        const y = end.top + end.height/2 - start.top - start.height/2;
        const flight = ghost.animate([{transform:'translate(0,0) scale(1)',opacity:.9},{transform:`translate(${x*.4}px,${y*.6-24}px) scale(.8)`,opacity:.85,offset:.55},{transform:`translate(${x}px,${y}px) scale(.2)`,opacity:0}],{duration:520,easing:'cubic-bezier(.3,.05,.45,1)',fill:'forwards'});
        animations.push(flight.finished);
      }
      if (destination.animate) animations.push(destination.animate([{transform:'scale(1)'},{transform:'scale(1.15)'},{transform:'scale(1)'}],{duration:380,delay:ghost?260:0,easing:'ease-out'}).finished);
      await Promise.race([Promise.allSettled(animations),new Promise(resolve=>setTimeout(resolve,800))]);
    } catch { /* Visual feedback must never interrupt checkout. */ }
    finally { ghost?.remove(); }
  }
  window.CPShopping = { announce, added };
})();
